const playVideo = async videoEl => {
  try {
    await videoEl.play();
  } catch (err) {
    // NotAllowedError: autoplay blocked (browser setting / low power mode) —
    // expected; the video never gets data-playing, so the cover behind it
    // stays visible. AbortError: element torn down mid-play (e.g. theme
    // editor section re-render) — benign. Anything else (unsupported codec,
    // bad source) is worth surfacing.
    if (err.name !== 'NotAllowedError' && err.name !== 'AbortError') {
      console.warn('[lazyloadVideo] play() failed:', err);
    }
  }
};

const loadVideo = videoEl => {
  const sourceEls = videoEl.querySelectorAll('source');
  sourceEls.forEach(sourceEl => {
    if (sourceEl.dataset.src) {
      sourceEl.src = sourceEl.dataset.src;
    }
  });

  // Browsers paint the element black between metadata load and the first
  // rendered frame — data-playing lets CSS keep the video hidden until
  // real frames are on screen (e.g. the hero fades it in over its cover).
  videoEl.addEventListener('playing', () => {
    videoEl.dataset.playing = 'true';
  }, { once: true });

  // Respect reduced motion: load but never start playback, so the cover
  // behind the video stays visible. Manual play still works when the
  // consumer renders controls.
  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (videoEl.autoplay && isReducedMotion) {
    videoEl.removeAttribute('autoplay');
  }

  videoEl.load();

  if (videoEl.autoplay) {
    playVideo(videoEl);
  }
};

const initLazyloadVideo = () => {
  const lazyVideoEls = document.querySelectorAll('[data-lazyload-video]');
  if (!lazyVideoEls.length) return;

  const lazyVideoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const videoEl = entry.target;

      // Already initialised by an earlier init pass — this util re-runs on
      // every shopify:section:load, and re-calling load() would abort and
      // restart a playing video. Just stop observing.
      if (!videoEl.querySelector('source[src]')) {
        loadVideo(videoEl);
      }

      lazyVideoObserver.unobserve(videoEl);
    });
  });

  lazyVideoEls.forEach(lazyVideoEl => {
    lazyVideoObserver.observe(lazyVideoEl);
  });
};

export default initLazyloadVideo;
